import styled from 'styled-components';

const StyledRing = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border-radius: 20px;
	transition: border 0.3s ease;
	cursor: pointer;
`;

const StyledContainer = styled.div<{ $selected: boolean }>`
	position: relative;
	width: 20px;
	height: 20px;
	border-radius: 20px;

	${StyledRing} {
		border: ${({ $selected }) =>
			$selected ? '2px solid #2d70da' : '2px solid transparent'};
	}

	&:hover {
		${StyledRing} {
			border: 2px solid #ffffff;
		}
	}
`;

export { StyledContainer, StyledRing };
